const dragOverlay = "_35sdzrmdoo";

export { dragOverlay };
import "./atom.drag-overlay.style.linaria.module.css";
//# sourceMappingURL=atom.drag-overlay.style.js.map
